import { jsx as a } from "react/jsx-runtime";
import { c as l } from "../index-rKuIKazb.js";
import '../assets/index8.css';const c = "_layout_1holf_2", e = {
  layout: c
}, n = (s) => {
  const { children: o, className: t } = s;
  return /* @__PURE__ */ a("div", { className: l(e.layout, t), children: o });
};
export {
  n as default
};
